export function getCheckoutUrl(raw: string): string | null {
  if (!raw.trim()) return null;
  try {
    const url = new URL(raw);
    return url.protocol === 'https:' ? url.href : null;
  } catch {
    return null;
  }
}
